
export interface ProgramRequestEnvelopeProgram{
    programRequestId: number;
    code: string;
    programName: string;
    classificationMark: string;
    status: string;
    statusId: number;
    historyId: number;
    isCurrent: boolean;
}

export interface SelectableProgramRequestEnvelopeProgram extends ProgramRequestEnvelopeProgram{
    isSelected: boolean;
}

export const createSelectableProgramRequestEnvelopeProgram = (envelopeProgram: ProgramRequestEnvelopeProgram) : SelectableProgramRequestEnvelopeProgram => {
    return {
        programRequestId: envelopeProgram.programRequestId,
        code: envelopeProgram.code,
        programName: envelopeProgram.programName,
        classificationMark: envelopeProgram.classificationMark,
        status: envelopeProgram.status,
        statusId: envelopeProgram.statusId,
        historyId: envelopeProgram.historyId,
        isCurrent: envelopeProgram.isCurrent,
        isSelected: false
    }
}